export default "__VITE_ASSET__a4896e8e__"